export default __webpack_public_path__ + "static/media/Monk's Boots of the Earthen Prison.065a0c15.jpg";